module.exports = __webpack_public_path__ + "img/icon-share.b2a548d5.png";